import React from 'react'
import { withNamespaces } from '>/i18n'
import withFestivalContext from '~/hoc/withFestivalContext'

export default (namespaces = []) => WrappedComponent => withFestivalContext(({ festivalName, ...rest }) => {
  const Component = withNamespaces([`homepage-${festivalName || 'rc'}`, ...namespaces]
  )(props => <WrappedComponent {...props} {...rest} festivalName={festivalName} />)
  return <Component />
})
